import axios from 'axios';
import * as R from 'ramda';

const axiosTemplate = (baseURL) => {
  const token = R.path(['token'], JSON.parse(localStorage.getItem('id_token')));
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': token,
      'Access-Control-Allow-Origin': '*',
    },
  });
};

export default axiosTemplate;
